import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedTime } from 'react-intl';

import { TranslatedCopy } from '../intl/TranslatedCopy';

const OutageTimeframe = ({ outage: { outageStart, outageEnd }, isNAUser }) => {
  const additionalProps = {
    year: '2-digit',
    month: 'numeric',
    day: 'numeric',
    timeZone: isNAUser ? 'America/Los_Angeles' : 'Africa/Maputo'
  };

  return (
    <>
      {isNAUser ? 'NA - ' : 'EU - '}
      <TranslatedCopy
        id='systemNotifications.until'
        values={{
          timeStart: <FormattedTime {...additionalProps} value={outageStart} />,
          timeFinish: <FormattedTime {...additionalProps} value={outageEnd} timeZoneName='short' />
        }}
      />
      {isNAUser ? '' : ' CEST'}
    </>
  );
};

OutageTimeframe.propTypes = {
  outage: PropTypes.shape({
    outageStart: PropTypes.any.isRequired,
    outageEnd: PropTypes.any.isRequired
  }).isRequired,
  isNAUser: PropTypes.bool.isRequired
};

export default OutageTimeframe;
